import OffsetPaginationMetaSchema from "@/schemas/OffsetPaginationSchema";
import { array, assign, nullable, number, object, string } from "superstruct";

import GiftRegistrantSchema from "./GiftRegistrantSchema";
import GiftRegistryItemSchema from "./GiftRegistryItemSchema";

const GiftRegistryWithItemsSchema = assign(
    OffsetPaginationMetaSchema,
    object({
        typeId: number(),
        title: string(),
        date: string(),
        id: number(),
        registrantId: number(),
        ordersCount: number(),
        createdAt: string(),
        updatedAt: nullable(string()),
        registrant: GiftRegistrantSchema,
        items: array(GiftRegistryItemSchema),
    })
);

export default GiftRegistryWithItemsSchema;
